import { forwardRef, InputHTMLAttributes } from "react";
import { Input } from "../Field";

/** A phone number box: `Input` with the phone keyboard and autofill, always left-to-right (also in Hebrew). Validation stays in the form schema. */
export const PhoneInput = forwardRef<HTMLInputElement, Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & { invalid?: boolean }>((props, ref) => (
  <Input ref={ref} type="tel" dir="ltr" inputMode="tel" autoComplete="tel" {...props} />
));
PhoneInput.displayName = "PhoneInput";
